import { render, staticRenderFns } from "./callLogList.vue?vue&type=template&id=58d56dcc&scoped=true&"
import script from "./callLogList.vue?vue&type=script&lang=js&"
export * from "./callLogList.vue?vue&type=script&lang=js&"
import style0 from "./callLogList.vue?vue&type=style&index=0&id=58d56dcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d56dcc",
  null
  
)

export default component.exports